<template>
  <NuxtLink :href="external ? external : computedUrl" :target="external?'_blank':''" rel="noopener noreferrer"
            class="content-item">
    <h2 class="content-item__title" v-html="external && externalTitle ? externalTitle : computedTitle"/>
    <AppButton :title="label" :end-icon="true" class="content-item__button"/>
  </NuxtLink>
</template>

<script setup lang="ts">
import {computed} from 'vue'
import {TArchivePage, TContentPage} from '../../types/page-types'
import {THighlightContent} from '~/types/block-types'
import {joinSlugId} from "~/utils/slug-id";

const props = defineProps<{
  data: TContentPage | TArchivePage | THighlightContent | null | undefined,
  label: String,
  external?: String,
  externalTitle?: String
  basePath?: String
}>()

const computedUrl = computed(() => {

  if (!props?.data) {
    return "/"
  }

  let base = (props.basePath) ? props.basePath : '/'
  
  // archive pages have an 'article type', content pages do not.
  if (props.data.belongs_to && !props.data.article_type) {
    base += `content-${props.data.belongs_to?.slug}/`
  }

  return base + joinSlugId(props.data)
})

const computedTitle = computed(() => {
  if (!props?.data) {
    return ''
  } else {
    return (props.data.title) ? props.data.title : ''
  }
})

</script>

<style scoped lang="postcss">
.content-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  @mixin app-blue-border-block;

  &:hover {
    background-color: var(--color-blue-aqua);
    color: var(--color-blue-prussian);
  }

  @media (--md) {
    flex-direction: row;
    align-items: center;
    gap: 1.5rem;
  }

  &__title {
    font-family: Midnight, sans-serif;
    line-height: 1.2;
  }

  &__button {
    margin-left: -0.125rem;
    flex-shrink: 0;
  }

  /* the button inverts together with the whole item */
  &:hover &__button,
  &:focus-visible &__button {
    background-color: var(--color-blue-prussian);
    color: var(--color-blue-aqua);
  }
}
</style>
